import { Directive } from '@angular/core';
import { MatSelect } from '@angular/material/select';

@Directive({
  selector: '[appSelectOverlayPosition]'
})
export class SelectOverlayPositionDirective {
  constructor(public _host: MatSelect) {
    this.setPositions();
  }

  setPositions(): void {
    if (this._host._positions.length > 1) {
      this._host._positions[0].offsetY = 30;
      this._host._positions[1].offsetY = -52;
    }
  }
}
